import { marqueeItems } from '@/data/site'

export function Marquee() {
  const repeatedItems = [...marqueeItems, ...marqueeItems]

  return (
    <div className="marquee-wrap" aria-hidden="true">
      <div className="marquee-track">
        {repeatedItems.map((item, index) => (
          <span className="marquee-item" key={`${item}-${index}`}>
            {item}
            <span className="marquee-dot" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  )
}
